import { AppState } from '..'
import { useAppSelector } from '../hooks'
import type { ITaskQueueState, QueueStatus } from './reducer'

export const useTaskQueue = (): ITaskQueueState =>
  useAppSelector((state: AppState) => state.taskQueue)

export const useQueueStatus = (): QueueStatus =>
  useAppSelector((state: AppState) => state.taskQueue.queueStatus)
